module.exports = __webpack_public_path__ + "static/media/about-page-banner-1.7888c46d.jpg";